function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.4 63.25L1.08.75H48c1.413 0 2.427 0 3.223.066.787.064 1.295.188 1.706.397a4.25 4.25 0 011.858 1.858c.21.411.333.919.397 1.706.065.796.066 1.81.066 3.223v48c0 1.413 0 2.427-.066 3.223-.064.787-.188 1.295-.397 1.706a4.251 4.251 0 01-1.858 1.858c-.411.21-.919.333-1.706.397-.796.065-1.81.066-3.223.066H24.4z",
  fill: "#7A0D1E",
  stroke: "#7A0D1E",
  strokeWidth: 1.5
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30 36l11-11M29.67 25l11.66 10.974",
  stroke: "#E98C73",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgFalse = function SvgFalse(props) {
  return React.createElement("svg", _extends({
    width: 56,
    height: 64,
    viewBox: "0 0 56 64",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='56' height='64' viewBox='0 0 56 64' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M24.4002 63.25L1.08034 0.75H48C49.4125 0.75 50.4268 0.750583 51.2229 0.81563C52.0103 0.879962 52.518 1.00359 52.9295 1.21322C53.7291 1.62068 54.3793 2.27085 54.7868 3.07054C54.9964 3.48197 55.12 3.9897 55.1844 4.77708C55.2494 5.57322 55.25 6.58749 55.25 8V56C55.25 57.4125 55.2494 58.4268 55.1844 59.2229C55.12 60.0103 54.9964 60.518 54.7868 60.9295C54.3793 61.7291 53.7291 62.3793 52.9295 62.7868C52.518 62.9964 52.0103 63.12 51.2229 63.1844C50.4268 63.2494 49.4125 63.25 48 63.25H24.4002Z' fill='%237A0D1E' stroke='%237A0D1E' stroke-width='1.5'/%3E %3Cpath d='M30 36L41 25' stroke='%23E98C73' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M29.6696 25.0003L41.3304 35.9744' stroke='%23E98C73' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";
export { SvgFalse as ReactComponent };